import './style.scss';

import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { useState } from 'react';
import { classNames } from 'primereact/utils';
import { submitContract } from 'apis/projects.api';
import { toast } from 'layout';
import { TOAST } from 'constant';
import GeneralInfoForm from '../GeneralInfoForm';

function Form({
  control,
  errors,
  handleSubmit,
  refetch,
  checkKeyDown,
  footerConfirmationPrompt,
  // checkValidation,
  disabled,
  isSendMailToOwner,
  isDirty,
  dirtyFields,
  watch,
  setValue,
  getValues,
  projectId,
  hasContractFile,
  totalExpenditurePP,
  isCreateLoading,
  projectType
}) {
  // #region Data
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);

  const { mutate, isLoading: isSendMailLoading } = useMutation(submitContract);

  const handleSubmitContract = () => {
    mutate(projectId, {
      onSuccess: () => {
        toast(TOAST.SUCCESS, t('notification.mail.success'));
        refetch();
      },
      onError: () => {
        toast(TOAST.ERROR, t('notification.server.error'));
      },
    });
  };

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('projectProposal.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setIsSubmitModalOpen(false)}
        autoFocus
      />
      <Button
        label={t('projectProposal.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          handleSubmitContract();
          setIsSubmitModalOpen(false);
        }}
      />
    </div>
  );
  const projectAppendixDeletedFileIds = watch('projectAppendixDeletedFileIds');
  const isDeleteAppendixFileIdsChanged =
    projectAppendixDeletedFileIds === undefined ? true : projectAppendixDeletedFileIds.length > 0;

  return (
    <div className="p-5">
      <Dialog
        header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
        visible={isSubmitModalOpen}
        position="center"
        style={{ width: '400px' }}
        onHide={() => setIsSubmitModalOpen(false)}
        draggable={false}
        footer={footerConfirmationSubmit}
      >
        <Message className="mt-4 w-full" severity="warn" text={t('contract.message')} />
      </Dialog>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <form onSubmit={handleSubmit} onKeyDown={checkKeyDown} autoComplete="off">
        <GeneralInfoForm
          errors={errors}
          control={control}
          footerConfirmationPrompt={footerConfirmationPrompt}
          isDirty={isDirty}
          dirtyFields={dirtyFields}
          watch={watch}
          setValue={setValue}
          getValues={getValues}
          disabled={disabled}
          totalExpenditurePP={totalExpenditurePP}
          projectType={projectType}
        />
        <div className="flex justify-content-end mt-2 gap-4">
          <Button
            className="w-10rem"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            label={t('contract.comeBack')}
            comeBack
            severity="danger"
            type="button"
            onClick={() => {
              navigate(-1);
            }}
          />
          {!disabled && (
            <>
              <Button
                type="submit"
                disabled={
                  isCreateLoading ||
                  (!isDeleteAppendixFileIdsChanged && !(isDirty && Object.keys(dirtyFields).length))
                }
                loading={isCreateLoading}
                className=" w-10rem "
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                {!isCreateLoading && t('contract.save')}
              </Button>
              <Button
                type="button"
                className="btn-control w-11rem"
                icon={classNames(
                  'pi mr-1 ',
                  { 'pi-spin pi-spinner': isSendMailLoading },
                  { 'pi pi-check': !isSendMailLoading }
                )}
                disabled={isSendMailLoading || hasContractFile || isSendMailToOwner || !projectId}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                severity="success"
                onClick={() => {
                  setIsSubmitModalOpen(true);
                }}
              >
                {t('contract.create')}
              </Button>
            </>
          )}
        </div>
      </form>
    </div>
  );
}

Form.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  // tab: PropTypes.number.isRequired,
  // checkValidation: PropTypes.func.isRequired,
  checkKeyDown: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isSendMailToOwner: PropTypes.bool,
  footerConfirmationPrompt: PropTypes.func,
  refetch: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dirtyFields: PropTypes.object,
  isDirty: PropTypes.bool,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  projectId: PropTypes.string.isRequired,
  hasContractFile: PropTypes.bool.isRequired,
  totalExpenditurePP: PropTypes.number,
  isCreateLoading: PropTypes.bool,
  projectType: PropTypes.string
};

Form.defaultProps = {
  disabled: false,
  isSendMailToOwner: false,
  dirtyFields: {},
  isDirty: false,
  footerConfirmationPrompt: () => null,
  totalExpenditurePP: 0,
  isCreateLoading: false,
  projectType: '',
  // data: {},
};

export default Form;
